export default [
  { value: 'desktop', text: 'Desktop' },
  { value: 'mobile', text: 'Mobile' },
  { value: 'tablet', text: 'Tablet' },
]